// ── Hotéis Tab ────────────────────────────────────────────────────────────────
import { getTrip }      from '@/store/tripState';
import { fmt, toArr,
         fmtR, statusBadge,
         sanitize }     from '@/helpers';
import { getPayerName } from '@/tabs/viagem';
import { attachmentViewerUrl } from '@/ui/attachmentViewer';
import type { Hotel }   from '@/types';

export function renderHoteis(): void {
  const el  = document.getElementById('hoteis-list');
  if (!el) return;
  const arr = (toArr(getTrip().hoteis ?? {}) as Hotel[])
    .sort((a, b) => (a.checkin ?? '').localeCompare(b.checkin ?? ''));
  if (!arr.length) { el.innerHTML = '<div class="empty">Nenhuma hospedagem adicionada.</div>'; return; }

  el.innerHTML = arr.map(h => {
    const payer      = h.pagador ? sanitize(getPayerName(h.pagador)) : '';
    const attachHtml = Object.values(h.attachments ?? {}).map(a =>
      `<a class="attach-chip" href="${attachmentViewerUrl(a)}" target="_blank" rel="noopener noreferrer">📎 ${sanitize(a.name)}</a>`
    ).join('');
    const safeUrl    = h.site ? (h.site.startsWith('http') ? h.site : 'https://' + h.site) : '';
    const siteHtml   = safeUrl
      ? `<a href="${sanitize(safeUrl)}" target="_blank" style="color:var(--lux-blue)">${sanitize(h.site!)}</a>`
      : '';
    return `
      <div class="card card-row">
        <div style="flex:1;min-width:0">
          <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:4px">
            <span class="card-title">🏨 ${sanitize(h.nome ?? '')}</span>
            ${statusBadge(h.status ?? '')}
          </div>
          <div class="card-sub">
            ${sanitize(h.cidade ?? '')}${siteHtml ? ' · ' + siteHtml : ''}
          </div>
          <div class="card-sub">
            ${fmt(h.checkin)}${h.checkinTime ? ' às ' + h.checkinTime : ''}
            → ${fmt(h.checkout)}${h.checkoutTime ? ' às ' + h.checkoutTime : ''}
            · ${h.noites ?? 0} noites
          </div>
          ${h.reserva ? `<div class="card-sub">Reserva: ${sanitize(h.reserva)}</div>` : ''}
          ${h.preco ? `<div class="card-sub">${fmtR(h.preco)}${payer ? ' · Pago por ' + payer : ''}</div>` : ''}
          ${attachHtml ? `<div class="attach-list">${attachHtml}</div>` : ''}
        </div>
        <div class="card-actions">
          <button class="icon-btn" onclick="window.__openAttachModal('hoteis','${h.id}')">📎</button>
          <button class="icon-btn" onclick="window.__openModal('hotel','${h.id}')">✏</button>
          <button class="icon-btn del" onclick="window.__delItem('hoteis','${h.id}')">×</button>
        </div>
      </div>`;
  }).join('');
}
